'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
/**
 * base
 * @module base
 * @author cynthia
 */

/**
 * isElement 是否为Elelement类
 * @private
 * @param  {element}  element 待验证参数
 * @return {Boolean}          true为是，false为否
 */
function isElement(element) {
    return element instanceof Element;
}
/**
 * getObjectType 获取对象类型
 * @private
 * @param  {Object} obj 对象
 * @return {String}     对象类型
 */
function getObjectType(obj) {
    var typeStr = Object.prototype.toString.call(obj);
    return typeStr.slice(8, -1);
}
/**
 * $ 获取单个dom元素
 * @static
 * @since 1.0.0
 * @param  {string} selectors   字符串，包含一个或是多个 CSS 选择器 ，多个则以逗号分隔
 * @param  {element} [baseElement=document] 基础元素
 * @return {element|object}             返回element 对象（DOM 元素）,匹配不到则返回null
 * @example
 * base.$('.className');
 * base.$('.className',document.body)
 */
function $(selectors, baseElement) {
    if (!selectors) {
        return null;
    }
    baseElement = isElement(baseElement) ? baseElement : document;
    return baseElement.querySelector(selectors);
}

/**
 * closest 获取最近祖先元素(可以取到本身)
 * @static
 * @since 1.0.0
 * @param  {element} baseElement 当前元素
 * @param  {string} selectors   选择器字符串
 * @return {element|object}             返回element 对象（DOM 元素）,匹配不到则返回null
 * @example
 * var baseEle = base.$('.className');
 * base.closest(baseEle,'.parents');
 */
function closest(baseElement, selectors) {
    var matchesSelector = baseElement.matches || baseElement.webkitMatchesSelector || baseElement.mozMatchesSelector || baseElement.msMatchesSelector;
    var ele = baseElement;
    while (ele) {
        if (matchesSelector.call(ele, selectors)) {
            return ele;
        } else {
            ele = ele.parentElement;
        }
    }
    return null;
}
/**
 * toggleClass 切换指定的类值
 * @static
 * @since 1.0.0
 * @param  {element|NodeList|HTMLCollection} baseElement 单个Element元素，或NodeList/HTMLCollection类数组
 * @param  {string} classN   类名
 * @return {void} 如果类存在，则删除它，如果不存在，则添加它
 * @example
 * toggleClass(baseEle,'className');
 */
function toggleClass(baseElement, classN) {

    if (!baseElement) {
        return;
    }

    var eleArr = isElement(baseElement) ? [baseElement] : Array.prototype.slice.call(baseElement, 0);
    var exp = new RegExp('(?:^|\\s)' + classN + '(?!\\S)', 'g');
    eleArr.forEach(function (ele) {
        if (!isElement(ele)) {
            return;
        }
        var classes = ele.className.split(' ');
        var existingIndex = classes.indexOf(classN);

        if (existingIndex >= 0) {
            ele.className = ele.className.replace(exp, '');
        } else {
            classes.push(classN);
            ele.className = classes.join(' ');
        }
    });
}

/**
 * addClass 添加指定的类值
 * @static
 * @since 1.0.0
 * @param {element|NodeList|HTMLCollection} baseElement 单个Element元素，或NodeList/HTMLCollection类数组
 * @param {string|Array} classN   类名，单个类名可用字符串，多个类名可用数组
 * @return {void}
 * @example
 * base.addClass(baseEle,'className');
 */
function addClass(baseElement, classN) {
    if (!baseElement) {
        return;
    }

    var eleArr = isElement(baseElement) ? [baseElement] : Array.prototype.slice.call(baseElement, 0);
    if (typeof classN === 'string') {
        classN = [classN];
    }
    eleArr.forEach(function (ele) {
        if (!isElement(ele)) {
            return;
        }
        // 2019-2-21: 避免增加多余的class，造成额外的repaint开销
        var classList = [];
        var oldClass = ele.className.split(/\s+/);
        classN.forEach(function (klass) {
            if (oldClass.indexOf(klass) < 0) {
                classList.push(klass);
            }
        });

        if (classList.length) {
            ele.className += ' ' + classList.join(' ');
        }
    });
}

/**
 * removeClass 删除指定的类值
 * @static
 * @since 1.0.0
 * @param {element|NodeList|HTMLCollection} baseElement 单个Element元素，或NodeList/HTMLCollection类数组
 * @param {string} classN   类名,单个类名可用字符串，多个类名可用数组
 * @return {void}
 * @example
 * base.removeClass(baseEle,'className');
 */
function removeClass(baseElement, classN) {

    if (!baseElement) {
        return;
    }

    var eleArr = isElement(baseElement) ? [baseElement] : Array.prototype.slice.call(baseElement, 0);
    if (typeof classN === 'string') {
        classN = [classN];
    }
    var exp = new RegExp('(?:^|\\s)(' + classN.join('|') + ')(?!\\S)', 'g');
    eleArr.forEach(function (ele) {
        if (!isElement(ele)) {
            return;
        }

        ele.className = ele.className.replace(exp, '');
    });
}

/**
 * hasClass 检查元素是否包含指定类值
 * @static
 * @since 1.0.0
 * @param {element} baseElement 目标元素
 * @param {string}  classN   类名
 * @return {boolean}            包含返回true，不包含返回false
 * @example
 * base.hasClass(baseEle,'className');
 */
function hasClass(baseElement, classN) {
    if (!isElement(baseElement)) {
        return null;
    }
    return baseElement.className.split(' ').indexOf(classN) > -1;
}

/**
 * [delegateEvent 事件代理]
 * @static
 * @since 1.0.0
 * @param  {element}   interfaceEle    父级dom
 * @param  {string}   selector     选择器
 * @param  {string}   eventType         事件名
 * @param  {Function} fn           回调函数,函数的this指向selector对应的target
 * @return {void}
 *
 */
function delegateEvent(interfaceEle, selector, eventType, fn) {
    interfaceEle.addEventListener(eventType, function (ev) {
        var e = ev || window.event;
        var target = e.target || e.srcElement;
        var cls = closest(target, selector);
        //如果目标元素与选择器匹配则执行函数
        if (cls && interfaceEle.contains(cls)) {
            if (typeof fn === 'function') {
                //将fn内部的this指向target（在此之前this都是指向的绑定事件的元素即interfaceEle）
                fn.call(cls, e);
            }
        }
    });
}

/**
 * extend 扩展函数
 * @static
 * @since 1.0.0
 * @param  {Object} target 目标对象,处理后会被改变
 * @param  {Object} source 源对象
 * @param  {Boolean} deep  是否深度拷贝扩展;深度扩展：当target与source的相同属性同为object或Array时，会对该属性对象进行递归extend;浅度扩展：只会遍历target对象的属性，不会再递归判断target对象中的属性对象
 * @return {Object}        处理后的target对象
 * @example
 * base.extend({a:1},{b:1});
 */
var extend = function ex(target, source, deep) {
    if (!target) {
        var sType = getObjectType(source);
        if (sType === 'Object') {
            target = {};
        } else if (sType === 'Array') {
            target = [];
        } else {
            target = source;
        }
    }
    for (var key in source) {

        if (!source.hasOwnProperty(key)) {
            continue;
        }
        var targetChild = target[key];
        var sourceChild = source[key];
        var targetChildType = getObjectType(targetChild);
        var sourceChildType = getObjectType(sourceChild);
        if (deep && (sourceChildType === 'Object' || sourceChildType === 'Array')) {
            // 如果targetChildType为undefined,应该也要深度拷贝
            if (targetChildType !== sourceChildType) {
                targetChild = sourceChildType === 'Object' ? {} : [];
                target[key] = targetChild;
            }
            // 严格模式下无法使用arguments.callee
            ex(targetChild, sourceChild, deep);
        } else {
            target[key] = sourceChild;
        }
    }
    return target;
};
/**
 * getUrlParam 获取url的特定参数值
 * @static
 * @since 1.0.0
 * @param  {String} paraName 参数名
 * @param  {String} fromGenre='search' 从哪个类型('search'/'hash')里找这个参数,传入不是'hash'时，都默认为search
 * @param {String} url 要解析的url,默认为window.location.href
 * @return {String|Object}          返回参数名对应的参数值，没有找到参数名，则返回null
 * @example
 * base.getUrlParam('a');
 */
function getUrlParam(paraName, fromGenre, url) {
    var reg = new RegExp('(?:^|&)' + paraName + '=([^&#]*)(?:&|#|$)'); //构造一个含有目标参数的正则表达式对象
    url = url || window.location.href;
    if (fromGenre === 'hash') {
        url = url.split('#')[1];
    }
    var searchStr = url.split('?')[1];
    var r = searchStr ? searchStr.match(reg) : null; //匹配目标参数
    if (r !== null) return decodeURIComponent(r[1]);
    return null; //返回参数值
}

/**
 * objToQueryStr 将对象转换为url的query字符串
 * @static
 * @since 1.0.0
 * @param  {Object} paramObj 参数对象
 * @return {String}          query字符串
 * @example
 * base.objToQueryStr({a:1,b:2});
 */
function objToQueryStr(paramObj) {
    var str = [];
    for (var p in paramObj) {
        if (!paramObj.hasOwnProperty(p) || paramObj[p] === undefined) {
            continue;
        }
        str.push(encodeURIComponent(p) + '=' + encodeURIComponent(paramObj[p]));
    }
    return str.join('&');
}

/**
 * getScrollTop 获取页面的scrollTop
 * @static
 * @since 1.0.0
 * @return {Number} top值
 * @example
 * base.getScrollTop();
 */
function getScrollTop() {
    return Math.max(document.documentElement.scrollTop, document.body.scrollTop);
}

/**
 * setBodyScrollTop 设置body的scrollTop
 * @static
 * @since 1.0.0
 * @param {Number} topValue [要设置的top值]
 * @return {void}
 * @example
 * base.setScrollTop(123);
 */
function setScrollTop(topValue) {
    document.documentElement.scrollTop = topValue;
    document.body.scrollTop = topValue;
}

var timingFnObj = {
    /**
     * [easeInQuad 缓动函数]
     * @private
     * @since 1.0.0
     * @param  {number} t [ 已过时间，已过时间 = 当前时间 - 动画开始时间，范围是[0-d]]
     * @param  {number} b [初始状态]
     * @param  {number} c [改变量，改变量 = 最终状态 - 初始状态]
     * @param  {number} d [动画持续时间]
     * @return {number}   [当前时间对应的状态值]
     */
    easeInQuad: function easeInQuad(t, b, c, d) {
        return c * (t /= d) * t + b;
    },
    /**
     * [linear 缓动函数]
     * @private
     * @since 1.0.0
     * @param  {number} t [ 已过时间，已过时间 = 当前时间 - 动画开始时间，范围是[0-d]]
     * @param  {number} b [初始状态]
     * @param  {number} c [改变量，改变量 = 最终状态 - 初始状态]
     * @param  {number} d [动画持续时间]
     * @return {number}   [当前时间对应的状态值]
     */
    linear: function linear(t, b, c, d) {
        return c * t / d + b;
    }
};

(function () {
    if (typeof window === 'undefined' || this !== window) {
        return;
    }
    var lastTime = 0;
    var vendors = ['webkit', 'moz', 'ms'];
    for (var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
        window.requestAnimationFrame = window[vendors[x] + 'RequestAnimationFrame'];
        window.cancelAnimationFrame = window[vendors[x] + 'CancelAnimationFrame'] || // Webkit中此取消方法的名字变了
        window[vendors[x] + 'CancelRequestAnimationFrame'];
    }

    if (!window.requestAnimationFrame) {
        window.requestAnimationFrame = function (callback, element) {
            var currTime = new Date().getTime();
            var timeToCall = Math.max(0, 16.7 - (currTime - lastTime));
            var id = window.setTimeout(function () {
                callback(currTime + timeToCall);
            }, timeToCall);
            lastTime = currTime + timeToCall;
            return id;
        };
    }
    if (!window.cancelAnimationFrame) {
        window.cancelAnimationFrame = function (id) {
            clearTimeout(id);
        };
    }
})();
/**
 * [Animate 动画函数类(单纯用于计算动画中各帧时各项数据的当前状态)]
 * @since 1.0.0
 * @class
 * @param {Object} options 动画参数对像
 * @param {Object|Number} options.start 初始状态值，若为对象，key要与options.end一一对应
 * @param {Object|Number} options.end 结束状态值，若为对象，key要与options.start一一对应
 * @param {Number} options.during 动画持续时间，单位毫秒
 * @param {String|Funciton} options.timingFn='easeInQuad' 动画的缓动函数 支持传'easeInQuad'或'linear' 或自定义缓动函数
 * @param {Function} onTick 每帧前要执行的函数，参数为与options.start对应的当前各个属性对应的属性值
 * @return {Animate} 返回Animate类
 * @example
    new base.Animate({
        start: 100,
        end: 500,
        during: 5000,
        onTick: function(value) {
            var $div = document.querySelector('.animate01');
            $div.style.width = value + 'px';
        }
    });
* @example
    new base.Animate({
        start: {
            width:100,
            height: 100
        },
        end: {
            width:500,
            height:400
        },
        during: 5000,
        onTick: function(value) {
            // 最后一帧会取end的值
            var $div = document.querySelector('.animate02');
            for (var key in value) {
                if (!value.hasOwnProperty(key)) {
                    continue;
                }
                $div.style[key] = value[key] + 'px';
            }

        },
        timingFn:'linear', // 默认为'easeInQuad' , 目前只支持'linear' ,'easeInQuad'，若还是不满足要求的话，可以传入缓动函数
         // [linear 缓动函数]
         // @private
         // @since 1.0.0
         // @param  {number} t [ 已过时间，已过时间 = 当前时间 - 动画开始时间，范围是[0-d]]
         // @param  {number} b [初始状态]
         // @param  {number} c [改变量，改变量 = 最终状态 - 初始状态]
         // @param  {number} d [动画持续时间]
         // @return {number}   [当前时间对应的状态值]
        // timingFn:(t, b, c, d)=>{return c * t / d + b;}
    });

 */
function Animate(options) {
    this.start = options.start;
    this.end = options.end;
    this.during = options.during;
    this.onTick = options.onTick;
    if (typeof options.timingFn === 'function') {
        this.timingFn = options.timingFn;
    } else {
        this.timingFn = timingFnObj[options.timingFn] || timingFnObj['easeInQuad'];
    }
    this.doAnimate();
}

/**
 * [doAnimate 执行动画]
 * @return {void}
 */
Animate.prototype.doAnimate = function () {
    var that = this;
    if (getObjectType(that.start) === 'Object') {
        this.delta = {};
        this._value = {};
        for (var key in this.start) {
            if (!this.start.hasOwnProperty(key)) {
                continue;
            }
            this.delta[key] = this.end[key] - this.start[key];
            this._value[key] = this.start[key];
        }
    } else {
        this.delta = this.end - this.start;
        this._value = this.start;
    }
    var startTime = undefined;
    var step = function step(timestamp) {
        if (!startTime) startTime = timestamp;
        var progress = timestamp - startTime;
        if (getObjectType(that.start) === 'Object') {
            for (var key in that.start) {
                if (!that.start.hasOwnProperty(key)) {
                    continue;
                }
                var start01 = that.start[key];
                that._value[key] = that.timingFn(progress, start01, that.delta[key], that.during);
            }
        } else {
            that._value = that.timingFn(progress, that.start, that.delta, that.during);
        }
        if (progress < that.during) {
            that.onTick(that._value);
            that.animationId = requestAnimationFrame(step);
        } else {
            that.onTick(that.end);
            cancelAnimationFrame(that.animationId);
        }
    };
    requestAnimationFrame(step);
};

/**
 * [escapeForHTML 转义html特殊字符]
 * @private
 * @since 1.0.0
 * @param  {String} html [html片段]
 * @return {String}      [转换后的html片段]
 */
function escapeForHTML(html) {
    return String(html).replace(/&(?!\w+;)/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#039;');
}

/**
 * template 生成模板引擎
 * @static
 * @since 1.0.0
 * @param  {String} str 模板字符串
 * @param {Object=} data 数据
 * @return {Function|String}     没有传入data时，返回一个模板引擎函数,参数为模板数据对象；传入data时，返回模板html字符串
 * @example
 * var tplStr = '<%dateList.forEach(function(date,index){%>'+
            '<li id="date<%=date%>" <%if(+date === +recentDate){%> class="active" <%}%> ><%=date%></li>'+
            '<%})%>';
    var tplFun = base.template(tplStr);
    var data={
        dateList:[12,23,45];
        recentDate:12
    };
    var tlpHtml = tplFun(data);
 */
function template(str, data) {
    var tpl = str.replace(/[\n\r]/g, '').replace(/<%=([\s\S]+?)%>/g, function (match, code) {
        return '\' + escapeForHTML(' + code + ')+\'';
    }).replace(/<%-([\s\S]+?)%>/g, function (match, code) {
        return '\' + ' + code + ' +\'';
    }).replace(/<%([\s\S]+?)%>/g, function (match, code) {
        return '\';\n ' + code + '\n tpl+=\'';
    }).replace(/\'\n/g, '\'').replace(/\n\'/gm, '\'');
    tpl = 'tpl = \'' + tpl + '\';';
    // tpl = tpl.replace(/''/g, '\'\\n\'');
    tpl = 'var tpl =\'\';\n with(obj){\ntry{' + tpl + '\n}catch(e){console.error(\'Template render error => \' ,e)};\n};\n return tpl;';
    var escapeStr = 'var escapeForHTML = ' + escapeForHTML.toString() + ';\n';
    var fun = new Function('obj', escapeStr + tpl);
    if (data) {
        return fun(data);
    } else {
        return fun;
    }
}
// requireJs函数中用到的已添加过的script元素map
var _scriptNode = {};
/**
 * 动态加载js（若globalName已存在，会直接执行loaded函数）
 * @function
 * @param {string} jsapi 加载的script代码链接
 * @param {string} globalName 加载的script代码吐出的全局变量名
 * @param  {function} loaded 成功回调
 * @returns {undefined} undefined
 * @example
 *  let apiJs = 'https://ssl.captcha.qq.com/TCaptcha.js';
 *  base.requireJs(apiJs, 'TencentCaptcha', () => {
 *      // js加载loaded成功后要做的事情
        this._initCaptcha(_props);
    });
 */
function requireJs(jsapi, globalName, loaded) {
    if (window[globalName]) {
        typeof loaded === 'function' && loaded();
        return;
    }
    if (_scriptNode[jsapi]) {
        _scriptNode[jsapi].addEventListener('load', loaded);
        return;
    }

    var doc = document;
    var head = doc.head || doc.getElementsByTagName('head')[0] || doc.documentElement;
    var node = doc.createElement('script');
    node.addEventListener('load', loaded);
    node.onerror = function (e) {
        throw new Error('[tool-base requireJs] ' + jsapi + ' load failed,' + e.message);
    };
    node.async = true;
    node.src = jsapi;
    head.appendChild(node);
    _scriptNode[jsapi] = node;
}

/**
 * [addStyleToDoc 往doc中加入样式]
 * @param {String} cssStyle [css]
 * @return {void}
 * @example
 *  base.addStyleToDoc(
        '.tcaptcha-transform{position: absolute!important;}'
    );
 */
function addStyleToDoc(cssStyle) {
    var style = document.createElement('style');
    style.type = 'text/css';
    var head = document.head || document.querySelector('head');
    head.appendChild(style);

    if (style.styleSheet) {
        style.styleSheet.cssText = cssStyle;
    } else {
        style.appendChild(document.createTextNode(cssStyle));
    }
}

exports.$ = $;
exports.closest = closest;
exports.toggleClass = toggleClass;
exports.addClass = addClass;
exports.removeClass = removeClass;
exports.hasClass = hasClass;
exports.delegateEvent = delegateEvent;
exports.extend = extend;
exports.getUrlParam = getUrlParam;
exports.objToQueryStr = objToQueryStr;
exports.getScrollTop = getScrollTop;
exports.setScrollTop = setScrollTop;
exports.Animate = Animate;
exports.template = template;
exports.requireJs = requireJs;
exports.addStyleToDoc = addStyleToDoc;